import {
  toWSDateString,
  useWSModalCustom,
  WSAlert,
  WSElement,
  WSFlexBox,
  WSForm,
  WSInfoBox,
  WSList,
  WSModal,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import React from "react";
import { useRenewRequirement } from "../../../../query/requirements/mutations/useRenewRequirement";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { RequirementStatusViewProps } from "../../types";
import { DataItem } from "../../../../shared/components/DataItem";

interface RenewRequirementProps {
  onClose: () => void;
  onSuccess: (requirement: IRequirementResponse) => void;
  requirement: IRequirementResponse;
  currentStatus: RequirementStatusViewProps;
}

const RenewRequirementModal: React.FC<RenewRequirementProps> = ({
  onClose,
  onSuccess,
  requirement,
  currentStatus
}) => {
  const [renewRequirement, renewRequirementMeta] = useRenewRequirement();

  const onSubmit = () => {
    renewRequirement(requirement.requirementId, {
      onSuccess: () => {
        onSuccess(requirement);
        onClose();
      }
    });
  };

  return (
    <WSForm onSubmit={onSubmit} defaultValues={{}}>
      <WSModal
        title="Start renewal"
        onClose={onClose}
        actions={{
          alignment: "fill",
          buttons: [
            {
              kind: "Secondary",
              label: "Cancel",
              onClick: onClose,
              type: "button"
            },
            {
              kind: "Primary",
              label: "Start renewal",
              type: "submit",
              loading: renewRequirementMeta.isLoading
            }
          ]
        }}
      >
        <WSList gap="XL">
          <WSFlexBox gap="M" wrap="nowrap">
            <WSElement>
              <WSText.ParagraphSm color="gray600" mb="S">
                Current status:
              </WSText.ParagraphSm>
              <WSPill {...currentStatus.pill}></WSPill>
              <WSText.ParagraphXs mt="XS" ml="S" color="gray400">
                {currentStatus.secondaryText}
              </WSText.ParagraphXs>
            </WSElement>
          </WSFlexBox>

          <WSInfoBox>
            <DataItem
              label="Current expiration date"
              value={toWSDateString(requirement.expiresAt, "input")}
            />
            <WSText.ParagraphSm color="gray700" mt="L">
              We'll automatically remind you 30 days before the expiration date.
            </WSText.ParagraphSm>
          </WSInfoBox>

          <WSAlert
            title="About starting renewals"
            icon="info-circle"
            theme="info"
          >
            By proceeding, a renewal process will start that allows you to
            update your documents anytime before automatic reminders begin.
            Existing valid documents will remain current until they expire.
          </WSAlert>

          <WSErrorMessage
            mt="XL"
            contextKey="Other"
            error={renewRequirementMeta.isError}
          />
        </WSList>
      </WSModal>
    </WSForm>
  );
};

export function useRenewRequirementAsPayeeModal() {
  return useWSModalCustom(RenewRequirementModal);
}
